<mat-card class="mb-16">
    <div class="fx-row align-items-center justify-content-between">
        <div class="fx-row fx-wrap align-items-baseline justify-content-end">
            <app-animated-number [value]="filteredDocuments.length" [class]="'bold main'"></app-animated-number>
            &nbsp;
            <span class="bold main">{{((filteredDocuments.length > 1 ? 'CASE.RENEWAL_LINKED_DOCUMENTS' :
                'CASE.RENEWAL_LINKED_DOCUMENT') | translate).toLowerCase()}}
            </span>
        </div>
        <button class="main-button ml-10" [cdkMenuTriggerFor]="addMenu" [disabled]="readonly"
            [class.disabled]="readonly">
            {{ (case && case.type === CaseType.RENEWAL_MAINTENANCE ? 'CASE.RENEWAL_MAINTENANCE.ADD_DOCS' :
            'CASE.ADD_PROOFS') |
            translate }}
        </button>
        <ng-template #addMenu>
            <mat-card class="menu-container p-0 elevation" style="max-width:180px;" cdkMenu>
                <div class="fx-column">
                    <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                        (click)="openLinkDialog()" cdkMenuItem>
                        <mat-icon class="dark mr-5" fontSet="material-icons-outlined">add_link</mat-icon>
                        <span class="text fx-flex">{{ 'CASE.LINK_PROOFS' | translate }}</span>
                    </div>
                    <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                        (click)="openUploadDialog()" cdkMenuItem>
                        <mat-icon class="dark mr-5" fontSet="material-icons-outlined">cloud_upload</mat-icon>
                        <span class="text fx-flex">{{ 'CASE.UPLOAD_PROOFS' | translate }}</span>
                    </div>
                </div>
            </mat-card>
        </ng-template>
    </div>
</mat-card>
<!-- <mat-card class="mb-16"> -->
<mat-accordion multi class="fx-flex-100">
    <mat-expansion-panel *ngFor="let _class of classes ; let index = index">
        <mat-expansion-panel-header>
            <div class="fx-row fx-flex-100 fx-wrap align-items-center justify-content-between"
                [class.clickable]="hasPS(_class)">
                <div class="fx-row align-items-center justify-content-start">
                    <div class="chip main" [matTooltipClass]="{'uzai-tooltip':true}"
                        [matTooltip]="'NICE_CLASSES.'+_class.classNumber | translate">
                        <span><b>{{'NICE_CLASSES.CLASS_NUMBER' |
                                translate}}{{_class.classNumber}}</b></span>
                    </div>
                    <div class="chip main outline ml-8" *ngIf="_class.productsServices && hasPS(_class)">
                        {{_class.productsServices.length}} {{((_class.productsServices.length > 1 ?
                        'ENTITIES.PRODUCTS_SERVICES'
                        :
                        'ENTITIES.PRODUCT_SERVICE') | translate).toLowerCase()}}
                    </div>
                    <div class="chip light outline ml-8" *ngIf="!hasPS(_class)">
                        {{'DOCUMENT.NO_PS_DETECTED' | translate}}
                    </div>
                    <div class="chip red plain ml-8" *ngIf="getClassProblems(_class) > 0"
                        [matTooltipClass]="{'uzai-tooltip':true}"
                        [matTooltip]="'CASE.RENEWAL_PS_WITHOUT_DOCUMENTS' | translate">
                        {{getClassProblems(_class)}}
                    </div>
                </div>
                <div class="fx-row align-items-center justify-content-end">
                    <div class="chip outline main mh-16" *ngIf="getClassDocuments(_class) > 0">
                        {{getClassDocuments(_class)}}
                        {{((getClassDocuments(_class) > 1 ?
                        'ENTITIES.DOCUMENTS' :
                        'ENTITIES.DOCUMENT') | translate).toLowerCase()}}</div>
                    <div class="chip red mh-16" *ngIf="getClassDocuments(_class) == 0">
                        {{'CASE.RENEWAL_NO_LINKED_DOCUMENT' | translate}}</div>
                    <mat-icon class="main clickable mr-16" matRipple fontSet="material-icons-outlined"
                        [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="'CASE.LINK_PROOFS' | translate"
                        (click)="$event.stopPropagation();openLinkDialog(_class.classNumber)">add_circle</mat-icon>
                </div>


            </div>
        </mat-expansion-panel-header>
        <mat-accordion multi>
            <mat-expansion-panel *ngFor="let productService of _class.productsServices ; let index = index ">
                <mat-expansion-panel-header>
                    <div class="fx-row fx-flex-100 justify-content-between align-items-center">
                        <span class="text bold fx-flex"
                            [class.red]="!productService.documents || productService.documents.length == 0">{{productService.label}}</span>
                        <div class="fx-row align-items-center justify-content-end">
                            <div class="chip main outline mh-16"
                                *ngIf="productService.documents && hasDocuments(productService)">
                                {{productService.documents.length}}
                                {{((productService.documents.length > 1 ?
                                'ENTITIES.DOCUMENTS' :
                                'ENTITIES.DOCUMENT') | translate).toLowerCase()}}
                            </div>
                            <div class="chip red mh-16 "
                                *ngIf="!productService.documents || !hasDocuments(productService)">
                                {{'CASE.RENEWAL_NO_LINKED_DOCUMENT' | translate}}
                            </div>
                            <mat-icon class="main clickable mr-16" matRipple fontSet="material-icons-outlined"
                                [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="'CASE.LINK_PROOFS' | translate"
                                (click)="$event.stopPropagation();openLinkDialog(_class.classNumber,productService.ref)">add_circle</mat-icon>
                        </div>

                    </div>
                </mat-expansion-panel-header>

                <div>
                    <table mat-table [dataSource]="productService.documents" style="z-index: 0;"
                        *ngIf="productService.documents && productService.documents.length > 0">
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>
                                <span class=" small light bold">
                                    {{'DOCUMENT.NAME' | translate}}
                                </span>
                            </th>
                            <td mat-cell *matCellDef="let document">
                                <div class="fx-row align-items-center justify-content-start clickable"
                                    (click)="toDocument(productService.ref,document)">
                                    <app-document-approval style="align-self: stretch;width: 4px;margin-right: 8px;"
                                        [approval]="document.approval"></app-document-approval>
                                    <img [src]="documentIcon(document)" [height]="35" class="mr-10" />
                                    <div class="fx-column name-container">
                                        <span class="text bold name">{{document?.name || '-'}}</span>
                                        <div class="fx-row align-items-center justify-content-start">
                                            <span class="small light">{{'DOCUMENT_CLASSES.'+document.class.toUpperCase()
                                                | translate}}</span>
                                            <mat-icon class="ml-5 main" fontSet="material-icons-outlined"
                                                *ngIf="document.confidential" [matTooltipClass]="{'uzai-tooltip':true}"
                                                [matTooltip]="'CONFIDENTIALITY.CONFIDENTIAL' | translate" inset
                                                inline>lock</mat-icon>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="nice">
                            <th mat-header-cell *matHeaderCellDef>
                                <span class=" small light bold">
                                    {{'DOCUMENT.NICE_CLASSIFICATION' | translate}}
                                </span>
                            </th>
                            <td mat-cell *matCellDef="let document">
                                <app-trademark-nice-classification [niceClassification]="document?.niceClassification"
                                    class="mt-5"></app-trademark-nice-classification>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="period">
                            <th mat-header-cell *matHeaderCellDef>
                                <span class=" small light bold">
                                    {{'DOCUMENT.PERIOD' | translate}}
                                </span>
                            </th>
                            <td mat-cell *matCellDef="let document">
                                <span class="text"
                                    *ngIf="document?.period && document.period.start && document.period.end">{{formatPeriod(document)}}</span>
                                <div class="text light"
                                    *ngIf="!document?.period || !document.period.start || !document.period.end">-
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="score">
                            <th mat-header-cell *matHeaderCellDef>
                                <span class=" small light bold">
                                    {{'CASE.DOCUMENT_RELEVANCE' | translate}}
                                </span>
                            </th>
                            <td mat-cell *matCellDef="let document">
                                <app-document-case-score [score]="document.score"></app-document-case-score>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>
                                <span class=" small light bold">
                                    {{'ACTIONS.ACTIONS' | translate}}
                                </span>
                            </th>
                            <td mat-cell *matCellDef="let document">
                                <mat-icon class="red clickable" fontSet="material-icons-outlined"
                                    (click)="unlink(document)" [matTooltipClass]="{'uzai-tooltip':true}"
                                    [matTooltip]="'CASE.UNLINK' | translate">remove_circle_outline</mat-icon>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                        </tr>
                    </table>
                    <div *ngIf="!productService.documents || productService.documents.length === 0">
                        <span class="text light">{{'CASE.RENEWAL_NO_LINKED_DOCUMENT' | translate}}</span>
                    </div>
                </div>

            </mat-expansion-panel>
        </mat-accordion>

    </mat-expansion-panel>
</mat-accordion>
<!-- </mat-card> -->